<template>
  <b-card class="tank-card p-3" v-if="tank">
    

    <b-card-body class="text-center">
    
      <div class="row text-dark">

        <div class="col-md-3 ">
          <span><b>Nivel: {{ floatToDecimal(tank.current_volume) }} / Capacidade: {{ floatToDecimal(tank.capacity) }} {{ tank.unit }}</b></span>
        </div>
        <div class="col-md-3 ">
          <span><b>Conteúdo: </b> {{ tank.content ? tank.content.toUpperCase() : '' }}</span>
        </div>
        <div class="col-md-3 ">
          <span><b>Tag:</b> {{ tank.tag }}</span>
        </div>
        <div class="col-md-3 ">
          <span><b>Última Atualização: </b>{{ tank.updated }}</span>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
export default {
  props: {
    tank: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    floatToDecimal(value) {
      return parseFloat(value).toFixed(2);
    },
  },
};
</script>

<style scoped>
.tank-card {
  border-radius: 8px;
  overflow: hidden;
  height: auto;
}

</style>
